import HttpClient from '../util/http/HttpClient'
import HttpClientAxios from '../util/http/HttpClientAxios'
import { Product } from '../objects/product'
import { Collection } from '../objects/collection'
import { Content } from '../objects/content'
import { Space } from '../objects/space'
import {
  FetchProductParams,
  FetchProductsParams,
  FetchCollectionParams,
  FetchCollectionPageParams,
  FetchContentParams,
  FetchPageParams,
  FetchPagesParams,
  FetchBlogParams,
  FetchArticleParams,
  FetchArticlesParams,
  FetchBlogPageParams,
  UpdateParams
} from './interfaces/parameters'

export interface NacelleConnectorParams {
  locale?: string
  httpClient?: HttpClient
}

export class NacelleConnector {
  apiClient: HttpClient
  locale: string

  constructor(params?: NacelleConnectorParams) {
    this.apiClient =
      params && params.httpClient ? params.httpClient : new HttpClientAxios()
    this.locale = params && params.locale ? params.locale : 'en-us'
  }

  updateDefaults(params?: UpdateParams) {
    if (params && params.locale) {
      this.locale = params.locale
    }
  }

  async product(_options: FetchProductParams): Promise<Product> {
    throw new Error('The default NacelleConnector does not return a product')
  }

  async products(_options: FetchProductsParams): Promise<Product[]> {
    throw new Error('The default NacelleConnector does not return products')
  }

  async collection(_options: FetchCollectionParams): Promise<Collection> {
    throw new Error('The default NacelleConnector does not return a collection')
  }

  async collectionPage(
    _options: FetchCollectionPageParams
  ): Promise<Product[]> {
    throw new Error(
      'The default NacelleConnector does not return a collection page'
    )
  }

  async content(_options: FetchContentParams): Promise<Content> {
    throw new Error('This NacelleConnector does not return a content item')
  }

  async page(_options: FetchPageParams): Promise<Content> {
    throw new Error('This NacelleConnector does not return a page item')
  }

  async pages(_options: FetchPagesParams): Promise<Content[]> {
    throw new Error('This NacelleConnector does not return pages')
  }

  async blog(_options: FetchBlogParams): Promise<Content> {
    throw new Error('This NacelleConnector does not return a blog')
  }

  async article(_options: FetchArticleParams): Promise<Content> {
    throw new Error('This NacelleConnector does not return an article')
  }

  async articles(_options: FetchArticlesParams): Promise<Content[]> {
    throw new Error('This NacelleConnector does not return an article')
  }

  async blogPage(_options: FetchBlogPageParams): Promise<Content[]> {
    throw new Error('This NacelleConnector does not return a blog page')
  }

  async space(): Promise<Space> {
    throw new Error('This NacelleConnector does not return a space')
  }

  async allProducts(_options?: { limit?: number }): Promise<Product[]> {
    throw new Error('This NacelleConnector does not return all products')
  }

  async allCollections(_options?: { limit?: number }): Promise<Collection[]> {
    throw new Error('This NacelleConnector does not return all collections')
  }

  async allContent(_options?: { limit?: number }): Promise<Content[]> {
    throw new Error('This NacelleConnector does not return all content')
  }
}
